














































































































































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import notificationService from '@/services/notificationService';
import Popup from '@/components/default/Popup.vue';
import { CreateMailTemplateCommand, MailTemplateType, MailTemplateDto, MailTemplatesClient, UpdateMailTemplateCommand } from '@/data/web-api-client';

import { DxForm, DxSimpleItem, DxRequiredRule, DxGroupItem, DxLabel } from 'devextreme-vue/form';

import { DxHtmlEditor } from 'devextreme-vue/html-editor';
import { DxLookup } from 'devextreme-vue';

@Component({
  components: {
    Popup,
    DxForm,
    DxSimpleItem,
    DxRequiredRule,
    DxGroupItem,
    DxLabel,
    DxHtmlEditor,
    DxLookup,
  },
})
export default class MailTemplatesDialog extends Vue {
  @Prop({ required: false, default: null })
  value?: MailTemplateDto | null;

  showTypeDialog: boolean = false;
  showTemplatePopup: boolean = false;
  formData: CreateMailTemplateCommand = new CreateMailTemplateCommand({
    name: '',
    subject: '',
    content: '',
    type: MailTemplateType.Quotation,
    language: '',
  });
  mailTemplateTypeEnum = MailTemplateType;
  languages: any[] = [];

  public async mounted() {
    this.languages = this.$store.getters['catalogs/list']('Languages')?.values ?? [];
  }

  public show() {
    if (this.value) {
      this.formData.content = this.value.content!.replaceAll('\n', '<br />');
      this.formData.name = this.value.name;
      this.formData.subject = this.value.subject;
      this.formData.type = this.value.type;
      this.formData.language = this.value.language;
      this.showTemplatePopup = true;
    } else {
      setTimeout(() => {
        Object.assign(this.formData, {
          name: '',
          subject: '',
          content: '',
          type: MailTemplateType.Quotation,
          language: this.languages.find((l) => l.value?.toLowerCase() === 'nederlands') ?? (this.languages.length ? this.languages[0] : ''),
        });
        this.showTypeDialog = true;
      }, 150);
    }
  }

  setType(type: MailTemplateType) {
    this.formData.type = type;
    this.showTypeDialog = false;
    this.showTemplatePopup = true;
  }

  async save() {
    try {
      const validationResult = this.formInstance.validate();
      if (!validationResult.isValid) {
        notificationService.invalidForm();
        return;
      }

      const client = new MailTemplatesClient(undefined, this.$axios);

      if (this.value?.id) {
        await client.update(
          this.value!.id!,
          new UpdateMailTemplateCommand({
            id: this.value.id,
            name: this.formData.name,
            subject: this.formData.subject,
            content: this.formData.content,
            type: this.formData.type,
            language: this.formData.language,
          })
        );
      } else {
        await client.create(this.formData);
      }

      this.showTemplatePopup = false;
      this.$emit('updated');
    } catch (err) {
      notificationService.failedToSave();
    }
  }

  get formInstance() {
    return (this.$refs.form as any).instance;
  }

  get languageOptions() {
    const items = this.languages.map((l) => ({
      value: l,
      text: l,
    }));

    return {
      dataSource: items,
      displayExpr: 'text',
      valueExpr: 'value',
      filterExpr: 'value',
      value: this.languages[0],
    };
  }

  get htmlEditorOptions() {
    return {
      toolbar: {
        items: [
          'bold',
          'italic',
          'underline',
          'separator',
          'alignLeft',
          'alignCenter',
          'alignRight',
          'alignJustify',
          'separator',
          'orderedList',
          'bulletList',
          'separator',
          'link',
          'separator',
          {
            formatName: 'size',
            formatValues: ['8pt', '10pt', '12pt', '14pt', '18pt', '24pt', '36pt'],
          },
          {
            formatName: 'header',
            formatValues: [false, 1, 2, 3, 4, 5],
          },
        ],
      },
    };
  }
}
